import type { IncomeSummaryShellProps } from '@/modules/admin/pages/components/IncomeSummaryShell/IncomeSummaryShell.types'

import { IncomeSummary } from '@/components/@Shared/UserManagmentCharts/IncomeSummary/IncomeSummary'

import { useAdminStatsServiceAdminStatsControllerGetIncomeStats } from '@/__generated__/queries'

export function IncomeSummaryShell({
  company,
  onUpdateChartsData,
}: IncomeSummaryShellProps) {
  const { data, isFetching, isLoading } =
    useAdminStatsServiceAdminStatsControllerGetIncomeStats({
      company,
    })

  return (
    <IncomeSummary
      data={data}
      isLoading={isLoading || isFetching}
      onUpdateChartsData={onUpdateChartsData}
    />
  )
}
